// 서포트리 워드마크. size는 이미지 높이(px). light=true면 다크 배경용 변주 사용.
export default function Logo({ size = 36, light = false }: { size?: number; light?: boolean }) {
  const src = light ? '/logo-light.png' : '/logo.png';
  return (
    <img
      src={src}
      alt="서포트리"
      height={size}
      style={{ height: size, width: 'auto', flexShrink: 0, display: 'block' }}
    />
  );
}
